import { render } from "./LocationsForm.vue?vue&type=template&id=a60ce016"
import script from "./LocationsForm.vue?vue&type=script&lang=js"
export * from "./LocationsForm.vue?vue&type=script&lang=js"

import "./LocationsForm.vue?vue&type=style&index=0&id=a60ce016&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__